class VelovStationLayer extends Layer {

  constructor(mapGL, isVisible = false) {
    super(mapGL, isVisible);

    this.name = 'velovstation';
    this.minZoom = 11;
    this.layerIds = ['velov-clusters', 'velov-cluster-count', 'velov-unclustered-point'];

    this.isClickable = true;

    this.load();
  }

  load() {

    this.mapGL.getMapObject().addSource(this.name + '-source', {
      'type': 'geojson',
      'data': CACHE_URL + '/getLayer?action=load&layer=velov',
      cluster: true,
      clusterMaxZoom: 14,
      clusterRadius: 70
    });

    // Clusters
    this.mapGL.getMapObject().addLayer({
      'id': this.layerIds[0],
      'type': 'circle',
      'source': this.name + '-source',
      'filter': ["has", "point_count"],
      'paint': {
        'circle-color': '#505050',
        'circle-radius': 15
      },
      'layout': {
        'visibility': this.isVisible ? 'visible' : 'none'
      },
      'minzoom': this.minZoom,
    });

    // Cluster count
    this.mapGL.getMapObject().addLayer({
      'id': this.layerIds[1],
      'type': 'symbol',
      'source': this.name + '-source',
      'filter': ['has', 'point_count'],
      'paint': {
        'text-color': '#ffffff'
      },
      'layout': {
        'text-field': '{point_count_abbreviated}',
        'text-size': 12,
        'visibility': this.isVisible ? 'visible' : 'none'
      },
      'minzoom': this.minZoom,
    });

    // Unclustered point
    this.mapGL.getMapObject().addLayer({
      'id': this.layerIds[2],
      'type': 'symbol',
      'source': this.name + '-source',
      'filter': ["!has", "point_count"],
      'layout': {
        'icon-image': "{icone}",
        'icon-allow-overlap': true,
        'visibility': this.isVisible ? 'visible' : 'none'
      },
      'minzoom': this.minZoom,
    });

    var thisLayer = this;

    this.mapGL.getMapObject().on('click', this.layerIds[2], function (e) {
      var coordinates = e.features[0].geometry.coordinates.slice();
      var popupContent = thisLayer.getPopupContent(e.features[0]);

      if (thisLayer.mapGL.popup.isOpen()) {
        thisLayer.mapGL.popup.remove();
      }

      thisLayer.mapGL.popup = new maplibregl.Popup({focusAfterOpen: false})
        .setLngLat(coordinates)
        .setHTML(popupContent)
        .setMaxWidth("none");

      thisLayer.mapGL.popup.on('open', function(){
        document.querySelector('.js-map-popup-refresh').click();
      });

      thisLayer.mapGL.popup.addTo(thisLayer.mapGL.getMapObject());
    });

    if (!Utils.isMobileOrTablet()) {
      this.mapGL.getMapObject().on('mouseenter', this.layerIds[2], function (e) {
        thisLayer.mapGL.getMapObject().getCanvas().style.cursor = 'pointer';
        var coordinates = e.features[0].geometry.coordinates.slice();
        var tooltipContent = thisLayer.getTooltipContent(e.features[0]);

        if (thisLayer.mapGL.tooltip.isOpen()) {
          thisLayer.mapGL.tooltip.remove();
        }

        thisLayer.mapGL.tooltip.setLngLat(coordinates)
          .setHTML(tooltipContent)
          .addTo(thisLayer.mapGL.getMapObject());
      });

      this.mapGL.getMapObject().on('mousemove', this.layerIds[2], function (e) {
        var coordinates = e.features[0].geometry.coordinates.slice();
        var tooltipContent = thisLayer.getTooltipContent(e.features[0]);
        thisLayer.mapGL.tooltip.setLngLat(coordinates).setHTML(tooltipContent);
        if (!thisLayer.mapGL.tooltip.isOpen()) {
          thisLayer.mapGL.tooltip.addTo(thisLayer.mapGL.getMapObject());
        }
      });

      this.mapGL.getMapObject().on('mouseleave', this.layerIds[2], function () {
        thisLayer.mapGL.getMapObject().getCanvas().style.cursor = '';
        thisLayer.mapGL.tooltip.remove();
      });
    }

    this.mapGL.getMapObject().on('click', this.layerIds[1], function (e) {

      var features = thisLayer.mapGL.getMapObject().queryRenderedFeatures(e.point, {
        layers: [thisLayer.layerIds[1]]
      });
      var clusterId = features[0].properties.cluster_id;

      thisLayer.mapGL.getMapObject().getSource(thisLayer.name + '-source').getClusterExpansionZoom(
        clusterId,
        function (err, zoom) {
          if (err) {
            return;
          }

          thisLayer.mapGL.getMapObject().easeTo({
            center: features[0].geometry.coordinates,
            zoom: zoom
          });
        }
      );
    });

    this.mapGL.getMapObject().on('mouseenter', this.layerIds[1], function () {
      thisLayer.mapGL.getMapObject().getCanvas().style.cursor = 'pointer';
    });

    this.mapGL.getMapObject().on('mouseleave', this.layerIds[1], function () {
      thisLayer.mapGL.getMapObject().getCanvas().style.cursor = '';
    });

    $(document).on('click', '.js-map-popup-refresh', function() {
      $.ajax({
        type: "GET",
        url: CACHE_URL + '/getLayer',
        data: '&action=get&layer=velov&id=' + $(this).data('id'),
        success: function(data) {
          var station = data[0];

          if (document.querySelector('.js-map-popup-stats-stands') !== null) {
            document.querySelector('.js-map-popup-stats-stands').textContent = station.stands;
            document.querySelector('.js-map-popup-stats-mechanical-bikes').textContent = station.mechanicalBikes;
            document.querySelector('.js-map-popup-stats-electrical-bikes').textContent = station.electricalBikes;
          }
        }
      });
    });
  }

  getTooltipContent(feature) {
    var tooltipContent = '<div class="map-tooltip">Station N°' + feature.properties.nom + '</div>';
    return tooltipContent;
  }

  getPopupContent(feature) {

    var popupContent = '<div class="map-popup">';
    popupContent += '<img class="map-popup__icon" src="' + IMG_PATH + '/Unsprited/mapicons/' + feature.properties.icone + '.svg" alt="" aria-hidden="true">';
    popupContent += '<div class="columns is-mobile is-variable is-4">';

    popupContent += '<div class="column">';
    if (feature.properties.nom !== null) {
      popupContent += '<span class="map-popup__title">Station N°' + feature.properties.nom + '</span>';
      popupContent += '<hr>';
    }

    popupContent += '<div class="map-popup__info">';
    if (feature.properties.adresse !== null) {
      popupContent += '<span class="map-popup__info-address">' + feature.properties.adresse + '</span>';
    }
    if (feature.properties.commune !== null) {
      popupContent += ', <span class="map-popup__info-commune">' + feature.properties.commune + '</span>';
    }
    if (feature.properties.bonus === "true") {
      popupContent += '<br><span class="map-popup__info-bonus">Station bonus</span>';
    }
    if (feature.properties.banking === "true") {
      popupContent += '<br><span class="map-popup__info-banking">CB acceptée</span>';
    }
    popupContent += '</div>';

    popupContent += '<hr>';

    popupContent += '<div class="map-popup__stats">';
    popupContent += 'Vélos disponibles : <span class="map-popup__stats-mechanical-bikes js-map-popup-stats-mechanical-bikes">' + feature.properties.mechanicalBikes + '</span><br>';
    popupContent += 'e-Vélo\'v disponibles : <span class="map-popup__stats-electrical-bikes js-map-popup-stats-electrical-bikes">' + feature.properties.electricalBikes + '</span><br>';
    popupContent += 'Places disponibles : <span class="map-popup__stats-stands js-map-popup-stats-stands">' + feature.properties.stands + '</span>';
    popupContent += '</div>';

    popupContent += '<hr>';

    popupContent += JourneyPlanner.getPopupContentActions(feature._geometry.coordinates, feature.properties.nom);

    popupContent += '</div>';

    popupContent += '<div class="column is-narrow">';

    var statusLabel = '';
    switch (feature.properties.statut) {
      case 0 : statusLabel = "Fermée"; break;
      case 1 : statusLabel = "Ouverte"; break;
      case 2 : statusLabel = "Service partiel"; break;
    }

    if (feature.properties.statut === 1) {
      popupContent += '<span class="map-popup__status">' + statusLabel + '</span>';
    } else {
      popupContent += '<span class="map-popup__status map-popup__status--error">' + statusLabel + '</span>';
    }

    popupContent += '<a href="javascript:;" class="map-popup__refresh js-map-popup-refresh" title="Rafraîchir les données" data-id="' + feature.properties.id + '">';
    popupContent += '<img src="' + IMG_PATH + '/Icons/refresh.svg" alt="">';
    popupContent += '</a>';
    popupContent += '</div>';

    popupContent += '</div>';
    popupContent += '</div>';

    return popupContent;
  }
}
